import {
  AdminConfigIcon,
  AgentsIcon,
  AlertingIcon,
  AnalyticsIcon,
  AssetsIcon,
  AudienceIcon,
  AudienceTemplateIcon,
  CampaignsIcon,
  ConnectionIcon,
  DashboardsIcon,
  DestinationIcon,
  ExperimentIcon,
  ExtensionsIcon,
  FlagIcon,
  FlowsIcon,
  FunctionIcon,
  GlobeIcon,
  IdeaIcon,
  IdentityIcon,
  JourneyIcon,
  JourneyTemplateIcon,
  MessagesIcon,
  MetricIcon,
  ModelIcon,
  PlanIcon,
  ProjectsIcon,
  SequencesIcon,
  SettingsIcon,
  SourceIcon,
  StylesIcon,
  SyncIcon,
  SyncTemplateIcon,
  TemplatesIcon,
  TrendsIcon,
} from "@hightouch/htui";
import { type BreadcrumbItem } from "@hightouch/htui";

/**
 * Keys cover every route that renders breadcrumbs (audited from crumbs call sites);
 * `undefined` = icon not yet chosen, breadcrumb renders icon-less.
 *
 * @see: https://www.figma.com/design/xhqBkvIjxQJ3xz9ZtLeEK0/Icons---Illustrations?node-id=3181-72&t=VNVFOlaWWEq4o5JU-1
 */
export const BREADCRUMB_PAGE_ICONS: Record<string, BreadcrumbItem["icon"]> = {
  syncs: SyncIcon,
  "realtime-syncs": SyncIcon,
  models: ModelIcon,
  sequences: SequencesIcon,

  audiences: AudienceIcon,
  journeys: JourneyIcon,
  "priority-lists": FlagIcon,
  schema: undefined, // deprecated legacy schema routes — intentionally icon-less
  "templates/audience-templates": AudienceTemplateIcon,
  "templates/journeys": JourneyTemplateIcon,
  "templates/sync-templates": SyncTemplateIcon,

  agents: AgentsIcon,
  "admin-tools": undefined, // internal tools

  "lifecycle-studio/projects": ProjectsIcon,
  "lifecycle-studio/templates": TemplatesIcon,

  "ad-studio/projects": ProjectsIcon, // briefs render here too
  "ad-studio/ideas": IdeaIcon,
  "ad-studio/insights": TrendsIcon,

  "ad-studio/templates": TemplatesIcon,

  "context-hub/brands": StylesIcon,
  "context-hub/knowledge": GlobeIcon,

  "ai/flows": FlowsIcon,
  "ai/configuration": SettingsIcon,
  "ai/admin": AdminConfigIcon,

  "native-delivery/campaigns": CampaignsIcon,
  "native-delivery/messages": MessagesIcon,
  "native-delivery/assets": AssetsIcon,
  "native-delivery/settings": SettingsIcon,

  analytics: AnalyticsIcon,
  dashboards: DashboardsIcon,
  experiments: ExperimentIcon,
  metrics: MetricIcon,

  idr: IdentityIcon,

  destinations: DestinationIcon,
  sources: SourceIcon,
  extensions: ExtensionsIcon,
  alerting: AlertingIcon,
  "extensions/alerting": AlertingIcon,
  connections: ConnectionIcon,

  "events/syncs": SyncIcon,
  "events/sources": SourceIcon,
  "events/destinations": DestinationIcon,
  "events/functions": FunctionIcon,
  "events/contracts": PlanIcon,
  "events/domains": undefined,
};

// Pathnames are workspace-slug-prefixed (/{slug}/audiences/123), so page
// segments start at index 2; two-segment keys beat one-segment keys.
export const resolveBreadcrumbIcon = (
  pathname: string,
): BreadcrumbItem["icon"] => {
  const [, , section, sub] = pathname.split("/");
  if (!section) {
    return undefined;
  }
  return (
    (sub ? BREADCRUMB_PAGE_ICONS[`${section}/${sub}`] : undefined) ??
    BREADCRUMB_PAGE_ICONS[section]
  );
};
